export default "__VITE_ASSET__DLb9KUKo__"